<template>
  <div
    class="widget-list-list"
    :style="{ cursor: isSettingMode ? 'default' : 'pointer' }"
    @mouseover="onMouseOver()"
    @mouseleave="onMouseLeave()"
    @click="onClick()"
  >
    <div>
      <div class="widget-list-list__name">
        <div class="icon" :style="getIconColor(item.eventLevel)"></div>
        <c-label
          id="eventMessage"
          :size="14"
          :color="$theme.COLOR.UI.UI01"
          :pointer="true"
          :ellipsis="true"
          >{{ item.eventMessage }}</c-label
        >
      </div>
      <div class="widget-list-list__date">
        <c-label :size="12" :color="$theme.COLOR.UI.UI04" :ellipsis="true">
          {{ $t('label.occurrenceTime') }} : {{ getFormatStartDate(item.startDt)
          }}<!-- | 지속시간 : {{ duration(item.durationSecond) }}--></c-label
        >
      </div>
    </div>
  </div>
</template>
<script>
import { useDateTimeFormat } from '@/composables/useDateTimeFormat';

const { formatDateTime, FULL_TIME_FORMAT } = useDateTimeFormat();

export default {
  props: {
    item: {
      // Event
      type: Object
    },
    // 위젯 설정 모드 여부
    isSettingMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hover: false
    };
  },
  computed: {
    getIconColor: function () {
      // event 타입별 아이콘 color
      return (eventLevel) => {
        const levelColor = {
          NORMAL: '#23d89e',
          INFORM: '#8a8f99',
          WARNING: '#ffcf33',
          FATAL: '#fb6a72',
          UNKNOWN: '#aeb8e9'
        };
        let iconColor = levelColor[eventLevel];
        return `background-color: ${iconColor}`;
      };
    }
  },
  mounted() {
    this.$forceUpdate();
  },
  methods: {
    getFormatStartDate(date) {
      return formatDateTime(new Date(date), FULL_TIME_FORMAT);
    },
    onClick() {
      if (this.isSettingMode) return;
      this.$emit('click');
      const startDt = this.$util.addOneMinute(this.item.startDt);

      window.app.searchEvent({
        ...this.item,
        startDt: startDt,
        isEventDetail: true
      });
    },
    onMouseOver() {
      this.hover = true;
    },
    onMouseLeave() {
      this.hover = false;
    }
  }
};
</script>

<style scoped lang="scss">
.icon {
  width: 12px;
  height: 12px;

  border-radius: 6px;
  margin-top: 6px;
  float: left;

  &.warning {
    background-color: #ffd035;
  }
}
.widget-list {
  &-list {
    padding: 12px 20px 12px 0px;
    position: relative;
    border-bottom: 1px solid $color--ui10;
    cursor: pointer;
    margin-right: 20px;

    &:hover {
      .widget-list-list__name .c-label {
        color: $color--primary !important;
      }
    }
    &:active {
      .widget-list-list__name .c-label {
        color: $color--primary !important;
      }
    }

    &:first-child {
      padding-top: 0px;
    }

    &:nth-last-of-type(1) {
      border: 0;
    }

    &__name {
      display: flex;
      gap: 8px;
    }

    &__date {
      padding-left: 20px;
      text-align: left;
    }

    &__arrow-icon {
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      right: 0px;
    }
  }
}
</style>
